<script>
	// The params prop contains values matched from the URL
	export let params = {}

	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import PainelBox from '../templates/PainelBox.svelte';
	import GradeCartoes from '../../componentes/GradeCartoes.svelte';
	import CartaoRetangulo from '../../componentes/cartoes/CartaoRetangulo.svelte';
	import {
		API,
		cabecalhoPadraoRequisicao,
		dadosUsuarioLS,
		gerarNrEntre,
		revstr,
		StatusHttp,
		TextoFeedback,
		TipoEvento,
		verificarSessionStorage
	} from '../../utils';

	const dispatch = createEventDispatcher();
	let parseAvaliacoes = [];
	let dadosUsuario;

	onMount(async () => {
		if (verificarSessionStorage('AVAL_TOKEN'))
			carregarAvaliacoes(`avaliacoes-finalizadas-pendentes/${params.status}`);
		else replace("/login");

		dadosUsuario = dadosUsuarioLS();
	});

	const acoesDisponiveis = (status, objeto) => {
		let acaoBaixarCertificado = {};

		// certificado de participação somente para avaliação de apresentações
		if (objeto.objetoAvaliadoEProjeto == false) {
			acaoBaixarCertificado = {
				url: API(`certificado-participacao/download/${objeto.objetoAvaliado.ano}/${gerarNrEntre(11111, 99999)}-${revstr(objeto.objetoAvaliado.projeto?.codigo)}-${revstr(dadosUsuario.cpf)}-${window.btoa(revstr(objeto.objetoAvaliado?.projeto?.codigo))}`),
				texto: 'Baixar Certificado (.PDF)'
			}
		}

		if (status == 'PENDENTE') {
			if (objeto.objetoAvaliadoEProjeto == true) {
				return [{
					url: `#/projeto/visualizar/anonimizado/${window.btoa(objeto.objetoAvaliado.codigo.split('').reverse().join(''))}/${objeto.id}`,
					texto: 'Abrir projeto'
				}];
			} else {
				return [{
					url: `#/apresentacao/visualizar/${objeto.objetoAvaliado.id}/${objeto.objetoAvaliado.projeto.codigo}`,
					texto: 'Ver apresentação'
				}];
			}
		}

		if (acaoBaixarCertificado.hasOwnProperty('url')) {
			return [{
				url: `#/avaliacao/visualizar/${objeto.id}`,
				texto: 'Ver avaliação realizada'
			}, acaoBaixarCertificado];
		}

		return [{
			url: `#/avaliacao/visualizar/${objeto.id}`,
			texto: 'Ver avaliação realizada'
		}];
	}

	const carregarAvaliacoes = async (endpoint) => {
		parseAvaliacoes = [];

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando avaliações ...',
		});


		const resposta = await fetch(API(endpoint), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("/login");
		});
		
		const { dados } = await resposta.json();

		if (dados.length == 0) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: 'Nenhuma avaliação disponível com este status.'
			});

			replace("/painel/avaliacao");
		}
		
		if (resposta.status == StatusHttp.OK) {
			Object.values(dados).forEach( objeto => {
				if (objeto.objetoAvaliadoEProjeto == true) {
					parseAvaliacoes.push({
						link: '#',
						titulo: `Projeto: ${objeto.objetoAvaliado.titulo}`,
						descricao: `
							<hr>
							Área de atuação: <strong class="has-text-info">${objeto.objetoAvaliado.alocacao}</strong>
							<br> 
							Modalidade: <strong class="has-text-info">${objeto.objetoAvaliado.modalidade}</strong>
							<br>
							Ano da avaliação: <strong class="has-text-info">${objeto.ano}</strong>`,
						acoes: acoesDisponiveis(params.status, objeto)
					});
				} else {
					parseAvaliacoes.push({
						link: '#',
						titulo: `Apresentação do trabalho: ${objeto.objetoAvaliado.projeto.titulo}`,
						descricao: `
							<hr>
							Inscrição: <strong class="has-text-info">${objeto.objetoAvaliado.id_zerofill}/${objeto.objetoAvaliado.ano}</strong>
							<br> 
							Área de atuação: | Modalidade: <small class="has-text-info">${objeto.objetoAvaliado.projeto.modalidade}</small>
							<br>
							Ano da avaliação: <strong class="has-text-info">${objeto.ano}</strong>`,
						acoes: acoesDisponiveis(params.status, objeto)
					});
				}
			});

			parseAvaliacoes = [...parseAvaliacoes];
		} else if (resposta.status == StatusHttp.HTTP_NOT_FOUND) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Aviso',
				conteudo: 'Nenhuma avaliação encontrada.'
			});
			
			replace("/painel");
		} else if (resposta.status == StatusHttp.UNAUTHORIZED) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: 'Usuário sem autorização pra acessar recurso.'
			});
			
			replace("/login");
		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: 'Erro desconhecido. Se persistir, favor entrar em contato pelo suporte.'
			});
			
			replace("/login");
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

	}
</script>

<PainelBox 
	largura="12" 
	deslocamento="0"
	titulo="Avaliações">
		
	<GradeCartoes itens={parseAvaliacoes} componente={CartaoRetangulo} flexWrap={false} parametros={{descricaoHtml: true}} />
</PainelBox>
